module.exports = __webpack_public_path__ + "img/9788963710853.ee539d57.jpg";